import { render, staticRenderFns } from "./CollegeDiscipline.vue?vue&type=template&id=132f5f80&"
import script from "./CollegeDiscipline.vue?vue&type=script&lang=js&"
export * from "./CollegeDiscipline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports